// Defect labels mapping
const DEFECT_LABELS = {
  0: 'cracking',
  1: 'damaged_footpath', 
  2: 'damaged_kerb_faded_paint',
  3: 'damaged_missing_cover_slabs',
  4: 'deteriorated_damaged_plants',
  5: 'edge_drop_uneven_shoulders',
  6: 'missing_plants_irregular_gaps',
  7: 'potholes',
  8: 'rain_cuts_shoulders',
  9: 'reduced_visibility_due_to_plant_growth',
  10: 'rutting',
  11: 'vegetation_growth_shoulders',
  12: 'water_stagnation'
};

// Feature labels mapping
const FEATURE_LABELS = {
  0: 'crash_barriers_guard_rails_damaged',
  1: 'damaged_blinkers_attenuators_delineators_anti_glare',
  2: 'damaged_bus_shelters_faded_markings_damaged_signages', 
  3: 'damaged_lights',
  4: 'damaged_road_studs_rumble_strips_hazard_markers',
  5: 'damaged_sign_boards_structures',
  6: 'encroachments_illegal_parking',
  7: 'faded_painting_barrier_guard_rail',
  8: 'faded_pavement_marking',
  9: 'inappropriate_diversions',
  10: 'missing_assets_change_detection',
  11: 'missing_poor_safety_measures',
  12: 'non_functional_lights',
  13: 'overall_cleanliness',
  14: 'pavement_marking_visibility_day_night',
  15: 'road_stud_rumble_strip_visibility_day_night',
  16: 'signage_visibility_day_night',
  17: 'unauthorized_median_openings',
  18: 'unauthorized_signboards_hoardings'
};

/**
 * Maps a defect label from numeric to descriptive text
 * @param {number|string} label - The numeric label
 * @returns {string} The descriptive defect label
 */
export const mapDefectLabel = (label) => {
  const numericLabel = typeof label === 'string' ? parseInt(label, 10) : label;
  return DEFECT_LABELS[numericLabel] || label;
};

/**
 * Maps a feature label from numeric to descriptive text
 * @param {number|string} label - The numeric label
 * @returns {string} The descriptive feature label
 */
export const mapFeatureLabel = (label) => {
  const numericLabel = typeof label === 'string' ? parseInt(label, 10) : label;
  return FEATURE_LABELS[numericLabel] || label;
};

/**
 * Maps any label (attempts both defect and feature mapping)
 * @param {number|string} label - The numeric label
 * @returns {string} The descriptive label
 */
export const mapLabel = (label) => {
  const numericLabel = typeof label === 'string' ? parseInt(label, 10) : label;
  return DEFECT_LABELS[numericLabel] || FEATURE_LABELS[numericLabel] || label;
};